import {memo} from 'react';

import {view} from '@sail/ui';

import {Conversation} from '@stripe-internal/conversations-client';
import {
  useConversationExceptions,
  useConversationInlineDataEvents,
} from '@stripe-internal/conversations-assistant';

import {MobileAssistantInput} from './MobileAssistantInput';
import {MobileAssistantLog} from './MobileAssistantLog';

type Props = {
  conversation: Conversation;
};

export const MobileConversationScreen = memo(function ConversationScreen({
  conversation,
}: Props) {
  useConversationExceptions(conversation);
  useConversationInlineDataEvents(conversation);

  return (
    <view.div
      data-testid="conversation-screen"
      css={{
        stack: 'y',
        height: 'fill',
        position: 'relative',
      }}
      // Setting the `aria-live` attribute so that screen readers can read new messages coming in.
      // We set it to `polite` so that new message don't interrupt the reading of previous messages.
      aria-live="polite"
    >
      <view.div css={{flex: '1 1 auto', minHeight: 0, overflow: 'hidden'}}>
        <MobileAssistantLog conversation={conversation} />
      </view.div>
      <view.div css={{flex: '0 0 auto'}}>
        <MobileAssistantInput conversation={conversation} />
      </view.div>
    </view.div>
  );
});
